import React from "react";

const ActivityDetails = () => {
  return (
    <div>
      <h3>This is Activity Details</h3>
    </div>
  );
};

export default ActivityDetails;
